import cx from 'classnames';

import { WemapBounds, WemapPinpoint } from '../../../design-system/components/wemap/types/Wemap';
import { WemapProvider } from '../../../design-system/components/wemap/WemapProvider';
import { WemapReact } from '../../../design-system/components/wemap/WemapReact';

import style from './MapSection.module.css';

type MapSectionProps = {
    bounds: WemapBounds;
    pinpoints: Array<WemapPinpoint>;
};

export const MapSection = ({ bounds, pinpoints }: MapSectionProps) => {
    return (
        <div className={cx(style.mapSection, 'col-lg-5 mb-40')}>
            <WemapProvider>
                <WemapReact
                    bounds={bounds}
                    clustering={false}
                    pinpoints={pinpoints}
                    isDrawerOpen={false}
                    trackingInformation={{
                        placeClicked: {
                            block: 'map',
                            card_number: 0,
                            click_type: 'button',
                        },
                    }}
                />
            </WemapProvider>
        </div>
    );
};
